



























import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color, TextureKinds, PaintStyle } from "../../domain/drawing";
import { ModelEditableMixin } from "../system/mixins";
import ColorPicker from "./ColorPicker.vue";
import TextureKindDropDownSelector from "./TextureKindDropDownSelector.vue";

@Component({
  components: {
    colorPicker: ColorPicker,
    kindSelector: TextureKindDropDownSelector,
  },
})
export default class PaintStyleEditor extends Mixins(ModelEditableMixin) {
  editingSource: PaintStyle;

  @Prop()
  pallet: Color[];

  get color(): Color {
    return this.editingSource
      ? this.editingSource.color
      : undefined;
  }

  set color(value: Color) {
    this.writeProperty(s => s.color = value);
  }

  get kind(): TextureKinds {
    return this.editingSource
      ? this.editingSource.kind
      : undefined;
  }

  set kind(value: TextureKinds) {
    this.writeProperty(s => s.kind = value);
  }

  get isAdditionalTextureSelectable(): boolean {
    return (!!this.kind || !!this.additionalTextureKind);
  }

  get additionalTextureKind(): TextureKinds {
    return this.editingSource
      ? this.editingSource.additionalTextureKind
      : undefined;
  }

  set additionalTextureKind(value: TextureKinds) {
    this.writeProperty(s => s.additionalTextureKind = value);
  }

  get defaultColor(): Color {
    return new Color("#FFFFFF");
  }
}
